import React, { Component } from 'react';
import styles from './CreateRequest.module.css';
import Select from 'react-select';
import { connect } from 'react-redux';
import { getModel, getModels, fetchModels } from '../../modules/models';
import {
  getMaterial,
  getMaterials,
  fetchMaterials,
} from '../../modules/materials';
import { getScene, getScenes, fetchScenes } from '../../modules/scenes';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { createRequest } from '../../modules/requests';
import Divider from '../../components/Divider';

class CreateRequest extends Component {
  state = {
    title: null,
    description: null,
    outputmaterials: [],
    outputmodels: [],
    outputscenes: [],
    reviewers: [],
    error: null,
    item: null,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  navTo = (id, cat) => {
    const { router } = this.context;
    const url = `/${cat}${id ? `/${id}` : ''}`;
    router.history.push(url);
  };

  createRequest = () => {
    const { router } = this.context;
    const { user, createRequest } = this.props;
    const {
      title,
      item,
      catogary,
      description,
      reviewers,
      outputmodels,
      outputmaterials,
      outputscenes,
    } = this.state;
    if (!title) {
      this.setState({ error: `reqeust title is required ` });
      return;
    }
    if (reviewers.length === 0) {
      this.setState({ error: `reqeust reviewers are required ` });
      return;
    }
    this.setState({ error: null });
    const attrs = {
      title,
      description,
      reviewers: reviewers.map(item => item.value),
      modelId: item._id,
      catogary,
      creator: user.username,
      outputs: {
        models: outputmodels.map(item => item.value),
        materials: outputmaterials.map(item => item.value),
        scenes: outputscenes.map(item => item.value),
      },
    };
    createRequest(attrs).then(id => router.history.push(`/requests/${id}`));
  };

  onChange = (value, key) => {
    this.setState({ [key]: value });
  };

  async componentDidMount() {
    const query = queryString.parse(window.location.search);
    const { id, catogary } = query;
    const {
      getModel,
      getScene,
      getMaterial,
      fetchModels,
      fetchMaterials,
      fetchScenes,
    } = this.props;
    let item = null;
    if (catogary === 'models') {
      item = await getModel(id);
      await fetchMaterials();
      await fetchScenes();
    } else if (catogary === 'materials') {
      item = await getMaterial(id);
      await fetchModels();
      await fetchScenes();
    } else if (catogary === 'scenes') {
      item = await getScene(id);
      await fetchModels();
      await fetchMaterials();
    }
    this.setState({
      item,
      title: item.friendlyName,
      catogary,
      [`output${catogary}`]: [{ value: id, label: '' }],
    });
  }

  optionsFormat = data => {
    if (!data) return [];
    return Object.keys(data).map(key => ({
      label: data[key].friendlyName,
      value: data[key]._id,
    }));
  };

  render() {
    const navOption = [
      'Dashboard',
      'Models',
      'Materials',
      'Scenes',
      'Requests',
    ];
    const { materials, models, scenes } = this.props;
    const {
      error,
      item,
      reviewers,
      catogary,
      outputmaterials,
      outputmodels,
      outputscenes,
    } = this.state;
    if (!item) return null;
    const modelOptions = this.optionsFormat(models);
    const materialOptions = this.optionsFormat(materials);
    const sceneOptions = this.optionsFormat(scenes);
    return (
      <div className={styles.newModel}>
        <div className={styles.header}>New Requst Review</div>
        <Divider />
        <div className={styles.requestTitle}>
          Title
          <span className={styles.required}>*</span>
        </div>
        <input
          className={styles.inputField}
          onChange={e => this.onChange(e.target.value, 'title')}
          defaultValue={item.friendlyName}
        />
        <div className={styles.requestTitle}> Description </div>
        <textarea
          className={styles.inputField}
          onChange={e => this.onChange(e.target.value, 'description')}
        />
        <div className={styles.requestTitle}>
          Reviewers
          <span className={styles.required}>*</span>{' '}
        </div>
        <Select
          multi={true}
          value={reviewers}
          onChange={data => this.onChange(data, 'reviewers')}
          className={styles.multiSelect}
          options={[
            { label: 'Ziyang', value: 'ziyang' },
            { label: 'Crate&Barrel', value: 'crateandbarrel' },
            { label: 'TC', value: 'tc' },
            { label: 'TK', value: 'tk' },
          ]}
        />
        <div className={styles.requestTitle}> Renders</div>
        {catogary !== 'models' && (
          <Select
            placeholder="Models"
            multi={true}
            value={outputmodels}
            className={styles.multiSelect}
            options={modelOptions}
            onChange={data => this.onChange(data, 'outputmodels')}
          />
        )}
        {catogary !== 'materials' && (
          <Select
            placeholder="Material"
            multi={true}
            value={outputmaterials}
            className={styles.multiSelect}
            options={materialOptions}
            onChange={data => this.onChange(data, 'outputmaterials')}
          />
        )}
        {catogary !== 'scenes' && (
          <Select
            placeholder="Background"
            multi={true}
            value={outputscenes}
            className={styles.multiSelect}
            options={sceneOptions}
            onChange={data => this.onChange(data, 'outputscenes')}
          />
        )}

        {error && <div className={styles.errorText}>{error} </div>}
        <button className={styles.saveButton} onClick={this.createRequest}>
          Request Review
        </button>
      </div>
    );
  }
}

export default connect(
  state => ({
    models: getModels(state),
    materials: getMaterials(state),
    scenes: getScenes(state),
  }),
  {
    getModel,
    getMaterial,
    getScene,
    createRequest,
    fetchModels,
    fetchMaterials,
    fetchScenes,
  }
)(CreateRequest);



// WEBPACK FOOTER //
// ./src/containers/CreateRequest/index.js